<template>
  <div style="width:30%;text-align: 2;float:left;padding:10px;">
    <div>API名称：{{ command }}</div>
    <textarea v-model="code" rows="10" style="width:100%;" />
    <div>
      <button @click="execCommand">{{ name }}</button>
    </div>
    <textarea :value="reply" style="width:100%;" rows="10" />
  </div>
</template>

<script>
// import IM from '../lib/CoolVideo.3c66c'
export default {
  name: "Command",
  props: ["name", "command", "code"],
  data() {
    return {
      reply: ""
    };
  },
  methods: {
    async execCommand() {
      const fn = new Function(`return ${this.code}`);
      console.log(fn);
      try {
        const data = await fn();
        this.reply = JSON.stringify(data);
      } catch (e) {
        this.reply = JSON.stringify(e);
      }
    }
  }
};
</script>

<style scoped></style>
